import base from "../baseurl";
import token from "../getTk";

const showAll = async (id) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });
  console.log(id, "Llego a la busqueda de hijos");
  const Create = await api
    .post("sons/showall", {
      json: {
        id,
      },
      timeout: false,
    })
    .json();
  return Create;
};

export default showAll;
